import { FC } from "react";

import { t } from "i18n/i18n";
import { IconText } from "mds/components/IconText";
import { Tooltip } from "mds/components/Tooltip";
import { RoundedButton } from "mds/components/buttons/RoundedButton";
import { LockLockedIcon } from "mds/icons";

export const PageLockedButton: FC = () => {
  return (
    <Tooltip content={t("lock_status.student_lock_warning")}>
      {(tooltipAnchorProps) => (
        <RoundedButton kind="primary" aria-disabled {...tooltipAnchorProps}>
          <IconText iconStart={<LockLockedIcon />} text={t("lock_status.page_locked")} />
        </RoundedButton>
      )}
    </Tooltip>
  );
};
